/**
 * Subscription IDs whose conversions should NOT be re-attributed on the
 * upsell step (their checkout pixels already fired upstream). Add new IDs
 * here to suppress upsell-time tracking for additional flows.
 */
export const SUPPRESSED_UPSELL_SUBSCRIPTION_IDS = [
  '38fdc474-fc42-4b55-a08b-0b7cc05f7ee2', // staging NP
  '4faad8a9-6720-4e9c-99cb-467eb5c6d7df', // prod NP
  '84676817-0a3f-4bab-a616-30531816307b' // prod NP
];

/**
 * Returns true when the user's most-recently-purchased subscription is in
 * the suppression list, signaling that upsell-time tracking (pixels in
 * mixins/pixel-tracking.js and conversion scripts in layouts/dashboard.vue)
 * should be skipped.
 *
 * @param {object} inventoryItemsObj - The `billing/inventoryItemsObj` getter.
 * @returns {boolean}
 */
const isUpsellPixelTrackingSuppressed = inventoryItemsObj => {
  const purchasedSubscriptionId =
    inventoryItemsObj?.subscriptions?.[0]?.item?.id;
  return (
    !!purchasedSubscriptionId &&
    SUPPRESSED_UPSELL_SUBSCRIPTION_IDS.includes(purchasedSubscriptionId)
  );
};

export default isUpsellPixelTrackingSuppressed;
